import "./HowItWorks.css";

function HowItWorks() {
  return (
    <div className="HowItWorks">
      <h1 className="title">How It Works</h1>
      <p>
        these recipes work for you, based on what you feel like eating and what
        you have in your pantry
      </p>
      <p>start by picking a protein type from the dropdown menu</p>
      <p>next choose the vegetables, you can add your own</p>
      <p>follow the recipe</p>
      <p>eat</p>
    </div>
  );
}

export default HowItWorks;
